// components/WebcamCaptureWrapper.js
import dynamic from "next/dynamic";

const WebcamCapture = dynamic(() => import("./webcamCapture"), { ssr: false });

export default WebcamCapture;
